import get from 'lodash/get';
import { SectionLink } from 'app/area/case/components/fact-box/types';

export const sectionFor = (props: SectionLink, id:string):number =>
  props.links 
  ? 
    get(props.links.find(l => l.id === id),'section') 
  : 
    undefined;
